import React, { Fragment } from 'react'

const Preloader = () => {
  return (
    <Fragment>
        
    </Fragment>
  )
}

export default Preloader